// @import "~@govbr-ds/core/src/components/header-list/header-list";

:host {
  display: block;
}

.br-header-list {
  br-list {
    display: none;
    position: absolute;
    top: 64px;
    left: 0;
    right: 0;
    min-width: max-content;
    box-shadow: var(--surface-shadow-sm);
    z-index: var(--z-index-layer-3);

    &[is-visible] {
      display: block;
    }
  }
}

@media (width >= 576px) {
  .br-header-list {
    br-list {
      top: 48px;
      right: auto;
      left: auto;
    }
  }
}

@media (width >= 1280px) {
  .br-header-list {
    br-list {
      &[is-horizontal] {
        position: static;
        box-shadow: none;
        min-width: auto;
      }
    }
  }
}
